@if (isLoading) {
  <div class="page-loader">
    <div class="loader-container">
      <img src="assets/icons/spinner.svg" />
      @if(showText) {
        <div class="label">Loading...</div>
      }
    </div>
  </div>
}
